/* holz4home · Dropshipping-Bestellautomatik
   - Copy-to-Clipboard für die Auftrags-Mailadresse
   - Schwebender CSV-Download-Button (sichtbar, wenn der Haupt-Button
     nicht im Viewport ist)
   - Hover-Tooltip auf der CSV-Beispieltabelle (Inhalte kommen aus
     dem Spalten-Glossar, damit Editor-Änderungen überall greifen) */
(function () {
  'use strict';

  function init() {
    /* ---- Copy-Pill ---- */
    var toast = document.querySelector('.h4h-ds-copied');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'h4h-ds-copied';
      toast.textContent = 'E-Mail-Adresse kopiert ✓';
      document.body.appendChild(toast);
    }
    var toastTimer;
    document.querySelectorAll('.h4h-ds-page .mailpill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var mail = pill.getAttribute('data-mail') || (pill.querySelector('code') && pill.querySelector('code').textContent) || '';
        if (!mail || !navigator.clipboard) return;
        navigator.clipboard.writeText(mail.trim()).then(function () {
          toast.classList.add('show');
          clearTimeout(toastTimer);
          toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
        });
      });
    });

    /* ---- Schwebender CSV-Download-Button ----
       Sichtbar, sobald der Haupt-Download-Button nicht im Viewport ist. */
    var mainBtn = document.querySelector('.h4h-ds-page .dl-row .btn-green');
    var fab = document.querySelector('.h4h-ds-fab');
    if (mainBtn && fab && 'IntersectionObserver' in window && !fab.dataset.bound) {
      fab.dataset.bound = '1';
      new IntersectionObserver(function (entries) {
        fab.classList.toggle('show', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(mainBtn);
    }

    /* ---- CSV-Tooltip ---- */
    var table = document.querySelector('.h4h-ds-page table.csv');
    if (!table) return;

    /* Spalten-Infos aus dem Glossar lesen (Reihenfolge = Tabellenspalten) */
    var cols = [];
    document.querySelectorAll('.h4h-ds-page .colgrid .colc').forEach(function (c) {
      var code = c.querySelector('code');
      var desc = c.querySelector('p');
      var fix = c.querySelector('.fixval');
      cols.push({
        code: code ? code.textContent.trim() : '',
        desc: (desc ? desc.textContent.trim() : '') + (fix ? ' — ' + fix.textContent.trim() : '')
      });
    });
    if (!cols.length) return;

    var tt = document.createElement('div');
    tt.className = 'h4h-ds-tt';
    document.body.appendChild(tt);

    table.querySelectorAll('tbody td').forEach(function (td) {
      td.addEventListener('mouseenter', function () {
        var info = cols[td.cellIndex];
        if (!info) return;
        tt.innerHTML = '';
        var codeEl = document.createElement('code');
        codeEl.textContent = info.code;
        tt.appendChild(codeEl);
        tt.appendChild(document.createTextNode(info.desc));
        tt.classList.add('show');
      });
      td.addEventListener('mousemove', function (e) {
        var w = tt.offsetWidth, h = tt.offsetHeight;
        var x = e.clientX + 16, y = e.clientY + 18;
        if (x + w > window.innerWidth - 12) x = e.clientX - w - 16;
        if (y + h > window.innerHeight - 12) y = e.clientY - h - 14;
        tt.style.left = x + 'px';
        tt.style.top = y + 'px';
      });
      td.addEventListener('mouseleave', function () { tt.classList.remove('show'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme-Editor: Section-Reload abfangen */
  document.addEventListener('shopify:section:load', init);
})();
